import axios from "axios";
import { clearActiveGroup } from "@/utils/activeGroup";

const http = axios.create({
  // baseURL: "/api",
  baseURL: "https://api.savinga.rw/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const activeGroupId = localStorage.getItem(
      "active_group_id"
    );

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    /*
     * Do not send X-Group-ID to routes that do not
     * require an active group.
     */
    const url = config.url || "";

    const shouldSkipGroupHeader =
      url.includes("/my-groups") ||
      url.includes("/owner") ||
      url.includes("/login") ||
      url.includes("/verify") ||
      url.includes("/request-code") ||
      url.includes("/auth/");

    if (
      activeGroupId &&
      !shouldSkipGroupHeader
    ) {
      config.headers["X-Group-ID"] =
        activeGroupId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const currentPath =
      window.location.pathname;

    const status =
      error?.response?.status;

    const message =
      error?.response?.data?.message;

    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      clearActiveGroup();

      if (currentPath !== "/login/sms") {
        window.location.href = "/login/sms";
      }

      return Promise.reject(error);
    }

    if (status === 403) {
      /*
       * Only clear the active group when the
       * selected group itself is invalid.
       *
       * Do not clear it for ordinary permission
       * errors within a valid group.
       */
      const groupAccessMessages = [
        "You do not have access to this group.",
        "Invalid or inactive active group.",
      ];

      if (
        groupAccessMessages.includes(message)
      ) {
        clearActiveGroup();

        if (
          currentPath !== "/select-group"
        ) {
          window.location.href =
            "/select-group";
        }
      }

      return Promise.reject(error);
    }

    if (
      status === 422 &&
      message === "Active group is required."
    ) {
      clearActiveGroup();

      if (currentPath !== "/select-group") {
        window.location.href =
          "/select-group";
      }

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default http;